import constants from '@/constants';
import EmrFormItem from '@/screens/CreateEmr/EmrInput/EmrFormItem';
import { IEmrInputProps } from '@/screens/CreateEmr/EmrInput/EmrInput';
import { DatePicker, Form } from 'antd';
import { DatePickerProps } from 'antd/lib';
import dayjs from 'dayjs';
import * as React from 'react';

export interface IEmrDateProps extends Pick<IEmrInputProps, 'name' | 'field' | 'labelProps'> {
  datePickerProps?: DatePickerProps;
  disabled?: boolean;
}

const EmrDate: React.FC<IEmrDateProps> = ({
  disabled,
  name,
  field,
  labelProps = {},
  datePickerProps = {},
  ...props
}) => {
  return (
    <EmrFormItem
      field={field}
      name={name}
      trigger="change"
      initialValue={!disabled && field?.default === 'today' ? dayjs() : undefined}
      getValueFromEvent={(val) => {
        return val ? dayjs(val).toISOString() : val;
      }}
      {...labelProps}
    >
      <Wrap field={field} datePickerProps={datePickerProps} disabled={disabled} />
    </EmrFormItem>
  );
};
export default EmrDate;

const Wrap = ({
  id,
  field,
  datePickerProps,
  value: formValue,
  disabled,
}: {
  id?: string;
  field?: IFieldConfig;
  value?: any;
  datePickerProps?: DatePickerProps;
  disabled?: boolean;
}) => {
  const form = Form.useFormInstance();
  const aid = id?.split('_');
  const format = field?.extra.format || constants.DATE_FORMAT;
  const o: any = {};
  if (format.includes('HH')) {
    o.showTime = true;
  }

  return (
    <DatePicker
      value={formValue ? dayjs(formValue) : undefined}
      onChange={(v: dayjs.Dayjs) => form.setFieldValue(aid, v)}
      placeholder={field?.placeholder}
      className={'base-date-picker w-full'}
      format={format}
      rootClassName={`root-base-date-picker`}
      {...datePickerProps}
      {...o}
      disabled={disabled}
    />
  );
};
